// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import {
  StyledHeaderSection,
  StyledHeadingText,
  StyledSubHeadingText,
} from '../styles/HeaderText.style';

const HeaderText = (props) => {
  const { headerText, layout, headerClassName, locator  } = props;
  const heading = headerText[0];
  const subHeading = headerText.length === 2 ? headerText[1] : {};

  return (
    <StyledHeaderSection layout={layout} className={headerClassName || `tabbed-carousel-header-section`}>
      <StyledHeadingText
        headerText={[heading]}
        locator={`${locator || `tabbed_carousel`}_heading_text`}
        fontFamily="secondary"
        fontWeight="bold"
        fontSize="fs22"
        useStyle
        noLinkWrap
        component="p"
      />
      {!isEmpty(subHeading) ? (
        <StyledSubHeadingText
          headerText={[subHeading]}
          locator={`${locator || `tabbed_carousel`}_sub_heading_text`}
          fontFamily="secondary"
          fontWeight="regular"
          fontSize="fs14"
          useStyle
          noLinkWrap
          component="p"
          customLayout={layout}
        />
      ) : (
        <></>
      )}
    </StyledHeaderSection>
  );
};

HeaderText.propTypes = {
  headerText: PropTypes.arrayOf(PropTypes.shape({})),
  layout: PropTypes.string,
  headerClassName: PropTypes.string,
  locator: PropTypes.string,
};

HeaderText.defaultProps = {
  headerText: [],
  layout: '',
  headerClassName: '',
  locator: ''
};

HeaderText.displayName = 'HeaderText';

export default HeaderText;
export { HeaderText as HeaderTextVanilla };
